import * as Colors from 'material-ui/styles/colors';

const width = 36;
const height = 36;

export default {
  buttonWrapper: {
    width,
    height,
    position: 'absolute',
    userSelect: 'none',
    WebkitUserSelect: 'none'
  },
  button: {
    width,
    height,
    backgroundColor: Colors.grey50,
    opacity: 0.5,
    border: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    boxShadow: '0 3px 10px rgba(0,0,0,0.16), 0 3px 10px rgba(0,0,0,0.23)',
    ':hover': {
      opacity: 1
    }
  }
};
